// extracted by mini-css-extract-plugin
module.exports = {"oeffnungszeiten":"Utilisation_oeffnungszeiten__us2Rv","shop":"Utilisation_shop__MfJQa","mytamina":"Utilisation_mytamina__rPhHx"};